module.exports = __webpack_public_path__ + "img/xnr3.bca02b68.jpg";